<div class="input-group">
  @if (label()) {
    <label class="input-label" [attr.for]="id()">{{ label() }}</label>
  }
  <input
    [attr.id]="id()"
    [name]="name()"
    class="input"
    [type]="inputType()"
    [formControl]="inputControl"
    pInputText
    [placeholder]="placeholder() ?? ''"
    [class.error]="control.invalid && (control.dirty || control.touched)"
  />
  @if (type() === 'password') {
    <a href="" (click)="showHidePassword($event)">
      <img
        class="show-hide-password"
        src="assets/img/icons/eye-icon.svg"
        alt="Show/Hide password"
      />
    </a>
  }
  <app-error-message [errorMessage]="errorMessage()" [name]="name()" [control]="control" />
  <app-error-message
    [errorMessage]="emailMessage()"
    [name]="name()"
    [control]="control"
    errorCode="email"
  />
</div>
